// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';


import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';
import { SchedulerComponent } from '../scheduler/scheduler.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';

import { Scheduler } from '../scheduler.model';
import { SchedulerService } from '../scheduler.service';

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class EventFormComponent implements OnInit {
  subscription: Subscription;
  @ViewChild('f', { static: true }) schedulerForm: NgForm;
  @ViewChild('matRef', { static: false }) matRef: MatSelect;
  @ViewChild('matRefG', { static: false }) matRefG: MatSelect;


  // inizializzazione array e campi utilizzati nella gestione pannelli
  oldId = 0; // ID del pannello prima della modifica
  scheduler: Scheduler; // pannello selezionato
  profile: string // profilo utente
  availables: string[]
  levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  mobile

  constructor(private als: AlertService, private schedulerService: SchedulerService, private auth: AuthenticationService,
    public dialog: MatDialog, public schedulerComponent: SchedulerComponent,
    public dataStorageService: ApiService, private utilsService: UtilsService) {
    this.subscription = schedulerService.refresh$.subscribe()
  }
  selectedAvailables = []
  groupids = []
  selectedGroups = []
  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }

  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    let agent = navigator.userAgent;
    agent = agent.toLowerCase()
    if (agent.includes("android") || agent.includes("iphone")) {
      this.mobile = true
    } else {
      this.mobile = false
    }
    var me = this
    this.dataStorageService.getGroupsList().subscribe(v => {
      this.groupids = v
    })
    this.dataStorageService.getAvailablesList().subscribe(v => {
      var p = []
      v.forEach(l => {
        l = l.split(" ")
        p.push(l[1] + " " + l[0])
      })
      this.availables = p
    })

    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    // si riempie la form coi valori preimpostati
      this.subscription = this.schedulerService.schedulerEditMode.subscribe(
        
        (id: number) => {
          me.selectedAvailables = []
      me.scheduler = me.schedulerService.getSchedulerByIndex(id);
      me.oldId = me.scheduler.id
      me.editMode = true;
      me.selectedAvailables.push(me.invertname(me.scheduler.available))
      setTimeout(() => {
        me.schedulerForm.form.patchValue({
          availables: me.selectedAvailables,
          //@ts-ignore
          start: me.scheduler.startdate ? new Date(parseInt(me.scheduler.startdate)) : "",
          //@ts-ignore
          end: me.scheduler.enddate ? new Date(parseInt(me.scheduler.enddate)) : "",
          level: me.scheduler.level ? me.scheduler.level : 0,
          sms: me.scheduler.sms ? me.scheduler.sms : false,
          mail: me.scheduler.mail ? me.scheduler.mail : false,
          office: me.scheduler.office ? me.scheduler.office : false,
          voice: me.scheduler.voice ? me.scheduler.voice : false,
          tag: me.scheduler.tag ? me.scheduler.tag : "",
        });
      },);
    });
    
  }
  invertname(name) {
    name = name.split(" ")
    return name[1] + " " + name[0]
  }
  change(event) {
    if (event.isUserInput) {
      if (event.source.selected) {
        this.selectedAvailables.push(event.source.value)
      } else {
        var index = this.selectedAvailables.indexOf(event.source.value);
        if (index !== -1) {
          this.selectedAvailables.splice(index, 1);
        }
      }
    }
  }
  changeGroup(event) {
    if (event.isUserInput) {
      if (event.source.selected) {
        this.selectedGroups.push(event.source.value)
      } else {
        var index = this.selectedGroups.indexOf(event.source.value);
        if (index !== -1) {
          this.selectedGroups.splice(index, 1);
        }
      }
    }
  }
  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var t = 0
    if (value.start && value.end && form.valid) {
      me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
      if (!me.editMode && me.selectedAvailables.length > 0 && me.selectedGroups.length > 0) {

        me.selectedGroups.forEach((group, i) => {
          me.selectedAvailables.forEach((val, i) => {
            setTimeout(function () {
              var currentavailable = val

              // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
              me.dataStorageService.getMaxScheduler().subscribe(v => {
                var temp = currentavailable.split(" ")
                currentavailable = temp[1] + " " + temp[0]
                // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
                t++

                var mess = new Scheduler(v + t,
                  currentavailable,
                  value.start,
                  value.end,
                  group,
                  value.level,
                  value.sms,
                  value.mail,
                  value.voice,
                  value.office,
                  value.tag
                );
                // si richiama il servizio di back-end per l'inserimento del pannello
                me.dataStorageService.storeScheduler(mess)

                // si richiamano i servizi di aggiornamento tabella
                me.scheduler = mess;
                me.schedulerService.addScheduler(mess);
              })
            }, t * 1000)
            t++
          });
        })
        // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
      } else if (me.editMode) {
        //@ts-ignore
        me.dataStorageService.getSchedule({id: me.oldId, available: me.scheduler.available, groupid: me.schedulerService.getGroupid(), date: me.scheduler.date}).subscribe(function (v) {
          v = v.body
          // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
          var mess = {
            id: me.oldId,
            //@ts-ignore
            available: v.available,
            //@ts-ignore
            oldstart: v.startdate,
            //@ts-ignore
            oldend: v.enddate,
            start: value.start,
            end: value.end,
            groupid: me.schedulerService.getGroupid(),
            level: value.level,
            sms: value.sms,
            mail: value.mail,
            voice: value.voice,
            office: value.office,
            tag: value.tag
          }
          // si richiama il servizio di back-end per l'inserimento del pannello
          me.dataStorageService.updateScheduler(mess)
        })

      }

      // dopo 1 secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.dataStorageService.getScheduler(me.schedulerService.getviewDate);
        me.schedulerService.updateSchedules()
        me.utilsService.hideLoader();
        me.onClear();
      }, (me.selectedAvailables.length + me.selectedGroups.length) * 1000)
    }

  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onDelete(form: NgForm) {

    var me = this
    const value = form.value;
    const conf = this.als.confirm("Sei sicuro di voler eliminare la reperibilita'?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        //@ts-ignore
        me.dataStorageService.getSchedule({id: me.oldId, available: me.scheduler.available, groupid: me.schedulerService.getGroupid(), date: me.scheduler.date}).subscribe(function (v) {
          // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
          var mess = {
            id: me.oldId,
            available: me.invertname(me.selectedAvailables[0]),
            //@ts-ignore
            oldstart: v.startdate,
            //@ts-ignore
            oldend: v.enddate,
            start: value.start,
            end: value.end,
            groupid: me.schedulerService.getGroupid(),
            level: value.level,
            sms: value.sms,
            mail: value.mail,
            voice: value.voice,
            office: value.office,
            tag: value.tag
          }
          me.dataStorageService.deleteSchedulers(mess)

          // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
          setTimeout(function () {
            me.dataStorageService.getScheduler(me.schedulerService.getviewDate);
            me.utilsService.hideLoader();
            me.schedulerService.updateSchedules()
            me.onClear();
          }, 2000)
        })
      }
      conf.unsubscribe();

    });

  }

  clear() {
    this.matRef.options.forEach((data: any) => data.deselect());
    this.selectedAvailables = []

  }

  cleargroups() {
    this.matRefG.options.forEach((data: any) => data.deselect());
    this.selectedGroups = []
  }
  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    if (this.matRef) this.matRef.options.forEach((data: any) => data.deselect());
    this.selectedAvailables = []
    this.selectedGroups = []

    this.editMode ? this.schedulerForm.setValue({
      availables: '',
      start: '',
      end: '',
      level: 0,
      sms: false,
      mail: false,
      office: false,
      voice: false,
      tag: ''

    }) : this.schedulerForm.setValue({
      start: '',
      end: '',
      level: 0,
      sms: false,
      mail: false,
      office: false,
      voice: false,
      tag: ''

    })
    this.editMode = false
  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
  import() {

    var me = this
    const dialogRef = this.dialog.open(Upload, {});
    dialogRef.afterClosed().subscribe(result => {
      me.dataStorageService.getScheduler(me.schedulerService.getviewDate);
      me.utilsService.hideLoader();
    });

  }
}

@Component({
  selector: 'upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['./style.scss']
})
export class Upload implements OnInit {

  constructor(public dialogRef: MatDialogRef<Upload>, public dataStorageService: ApiService, private utilsService: UtilsService) { }
  fileToUpload: File = null;
  jsontosave
  loaded
  ngOnInit() {

  }
  handleFileInput(files: FileList) {
    var me = this
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        me.jsontosave = me.csvJSON(csv)
        me.loaded = true
      }
    }
  }
  uploadFileToActivity() {
    var me = this
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState == 4 && (this.status == 200 || this.status == 500)) {
        me.dialogRef.close();
      }
    };
    xmlHttp.open("POST", 'https://sosimperium.multiutilitydelgarda.eu:8001/csvavailabilities', false); // false for synchronous request
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.send(this.jsontosave);
    me.loaded = false
    // this.dataStorageService.storeCsvAvailabilities(this.jsontosave)
  }

  csvJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {

      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        if (headers[j] && currentline[j]) {
          headers[j] = headers[j].replace(/[\n\r]+/g, '');
          currentline[j] = currentline[j].replace(/[\n\r]+/g, '');
          obj[headers[j]] = currentline[j];
        }
      }

      result.push(obj);

    }
    return JSON.stringify(result); //JSON

  }
}